import http, { url } from '../../http'

const API_URL = "maintenance"

class maintenanceAPI {

  async save(maintenance) { 
    const response = await http(`${API_URL}/save`, 'POST', maintenance)
    return response
  } 

  async getAllmaintenancePage(id, page) {
    const response = await http(`${API_URL}/${id} ?page=${page}`, 'POST', {
      page: page
    })
    return response || null
  }
 

  async getmaintenance(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  /** Alerta de mantenimientos próximos a vencer/vencidos de la empresa (ítem 4.2.5). */
  async alerts(companyId, days = 30) {
    const response = await http(`${API_URL}/alerts/${companyId}?days=${days}`, 'GET')
    return response || null
  }

  async updatemaintenance(id, maintenance) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', maintenance)
    return response
  }
 
}

export default new maintenanceAPI()